import { render, staticRenderFns } from "./c-read-company-address.vue?vue&type=template&id=b269ad3c&scoped=true"
import script from "./c-read-company-address.vue?vue&type=script&lang=js"
export * from "./c-read-company-address.vue?vue&type=script&lang=js"
import style0 from "./c-read-company-address.vue?vue&type=style&index=0&id=b269ad3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b269ad3c",
  null
  
)

export default component.exports